//
//
//
//
//
//
//
//

import Loader from "@/globals/Loader";
import { Header } from "@/matrix/events";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Matrix",
  components: {
    matrixLoader: Loader
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["status", "authorized"])
  },
  methods: {
    ...mapActions(["initialize"]),
    emit() {
      if (this.status) {
        Header.$emit("TOGGLED", null);
      }
    }
  },
  async created() {
		let id = document.querySelector('#tableId').value
		let edit = document.querySelector('#editMode')

		if (edit && edit.value.toLowerCase() === 'true') edit = true
		else edit = false
		
    await this.initialize({id, edit});
  }
};
